import { render } from "./DHLExpressPickupIndex.vue?vue&type=template&id=a82c9782"
import script from "./DHLExpressPickupIndex.vue?vue&type=script&lang=js"
export * from "./DHLExpressPickupIndex.vue?vue&type=script&lang=js"

import "./DHLExpressPickupIndex.vue?vue&type=style&index=0&id=a82c9782&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__